import { render, staticRenderFns } from "./DomainRedirects.vue?vue&type=template&id=20046dea&"
import script from "./DomainRedirects.vue?vue&type=script&lang=js&"
export * from "./DomainRedirects.vue?vue&type=script&lang=js&"
import style0 from "./DomainRedirects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports